module.exports = {
      id: "ic-stochastic-oscillator-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-stochastic-oscillator-usage",
      toString: function () {
        return this.url;
      }
    }